module.exports = __webpack_public_path__ + "563b6332f28534e8ef13c825f9e1df33.png";